import { render, staticRenderFns } from "./StageViewNG.vue?vue&type=template&id=ddc56e5e&"
import script from "./StageViewNG.vue?vue&type=script&lang=js&"
export * from "./StageViewNG.vue?vue&type=script&lang=js&"
import style0 from "./StageViewNG.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StageViewNG.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
